import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { roundValue, safeParseFloat } from "lib/number";
import memoizeOne from "memoize-one";
import { getChildrenTotalRetail, getGrandTotalRetail } from "../column-formula/total-retail";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

const memoGetGrandTotalRetail = memoizeOne(
    (factoryOptions, getterParams) => {
        return referenceMetricValueOrCompute(
            () => {
                let totalUnits = 0;
                getterParams.api.forEachNodeAfterFilter((rowNode) => {
                    // We only need to include outer row. `getGrandTotalRetail` will count nested children
                    if (rowNode.level === 0) {
                        totalUnits += getGrandTotalRetail(factoryOptions, {
                            ...getterParams,
                            node: rowNode,
                            data: rowNode.data,
                        });
                    }
                });

                return totalUnits;
            },
            getterParams,
            MetricsKind.TOTAL_RETAIL,
            undefined,
            undefined,
            factoryOptions.disableSiblingOptimization
        );
    },
    (newArgs, oldArgs) => newArgs[1].colDef.colId === oldArgs[1].colDef.colId
);

export const DOOR_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    const totalRetail = referenceMetricValueOrCompute(
        () => {
            let totalRetail = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenTotalRetail` will count nested children
                if (rowNode.level === 0) {
                    totalRetail += getChildrenTotalRetail(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalRetail;
        },
        getterParams,
        MetricsKind.TOTAL_RETAIL,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!totalRetail) {
        return 0;
    }

    // For grand total, this will always be 100
    if (totalRetail > 0 && getterParams.column.getColDef().type === ColumnTypes.AllDimensionTotal) {
        return 100;
    }

    // Get aggregrated total retail of a node group across all deliveries and groups
    const grandTotalRetail = memoGetGrandTotalRetail(factoryOptions, getterParams);

    const unitDoorPercentagePlan = safeParseFloat(totalRetail / grandTotalRetail, 0) * 100;
    const roundedValue = roundValue(unitDoorPercentagePlan, 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
